module.exports = __webpack_public_path__ + "static/media/folder.1de6de73.svg";